import gql from 'graphql-tag';

export default gql`
  query topMenu {
    application(name: HOTELONLYBOOKING) {
      mainMenu {
        __typename
        id
        title
        icon
        link {
          target
          ... on AbsoluteLink {
            url
          }
          ... on RelativeLink {
            path
          }
        }
        ... on ExpandableMenuItem {
          expanded
          items {
            id
            title
            icon
            link {
              target
              ... on AbsoluteLink {
                url
              }
              ... on RelativeLink {
                path
              }
            }
          }
        }
      }
      userMenu {
        __typename
        id
        title
        icon
        link {
          __typename
          target
          ... on AbsoluteLink {
            url
          }
          ... on RelativeLink {
            path
          }
        }
        ... on ExpandableMenuItem {
          __typename
          expanded
          items {
            id
            title
            icon
            link {
              __typename
              target
              ... on AbsoluteLink {
                url
              }
              ... on RelativeLink {
                path
              }
            }
          }
        }
      }
    }
  }
`;
